export default __webpack_public_path__ + "static/media/transport2.5a421312.png";